import React from 'react';
import useRecorder from "../../hooks/useRecorder";
import Header from "../../components/Header";
import StarBackground from "../../components/StarBackground";
import Timeline from "../../components/Timeline";
import ExeCore from "../../components/ExeCore";
import Controls from "../../components/Controls";
import Character from "../../components/Character";
import Planet from "../../components/Planet";
import config from './sentencesConfig';


export default function Sentences({ level = 1, onValidate }) {
    const overlayImage = `/assets/images/sentencesImages/${level}.png`;
    const {
        startRecording,
        stopRecording,
        isRecording
    } = useRecorder();
    
    return (
        <div className="sentences-wrapper">
            <Header color={config.headerColor} />
            
            <StarBackground imagePath={config.planetBackground} />
            
            <Timeline current={level} total={config.totalLevels || 14} />
            
            <ExeCore image={config.marsImage} size={config.marsSize} />
            <ExeCore image={overlayImage} size={config.marsSize} className="overlay-core" />
            
            <Controls
                colors={config.controlColors}
                onRepeat={() => console.log('Repeat')} // This prop is not currently used by Controls.js
                onStartRecording={startRecording} // Pass the explicit startRecording function
                onStopRecording={stopRecording}   // Pass the explicit stopRecording function
                onValidate={onValidate}
                recording={isRecording} // Pass isRecording for the microphone visual feedback
                context={level.toString()}
                recordingMode="post-playback" // *** Set this prop for the desired behavior ***
            />
            <Character
                name={config.character}
                position='right'
            />
            <Planet image={config.planetImage} />
        </div>
    );
}
